import React, { FC } from 'react';

import styles from './ToolBar.module.scss';

export interface Props {
  children?: React.ReactNode;
}

export interface TextProps {
  children?: string;
}

export interface ButtonProps {
  icon: React.FC;
  disabled?: boolean;
  title: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  testId?: string;
}

export const ToolBarComponents: FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  return <div className={styles.toolbar}>{props.children}</div>;
};

export const ToolBarContainer: FC<React.PropsWithChildren<Props>> = (props) => {
  return <div className={styles.toolbarContainer}>{props.children}</div>;
};

export const ToolBarText: FC<React.PropsWithChildren<TextProps>> = (props) => {
  return <div className={styles.toolbarText}>{props.children}</div>;
};

export const ToolBarButton: FC<ButtonProps> = (props) => {
  const Icon = props.icon as any;
  return (
    <a
      data-disabled={props.disabled}
      onClick={props.onClick}
      title={props.title}
      className={styles.toolbarButton}
      data-test-id={props.testId}
    >
      <Icon className={styles.icon} />
    </a>
  );
};
